module.exports = __webpack_public_path__ + "img/plane-engines.e9a2ab42.svg";